<script>
  import {Bar} from 'vue-chartjs'

  export default {
    extends: Bar,
    name: "guests-count",
    mounted() {
      // Overwriting base render method with actual data.
      this.renderChart({
        labels: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь'],
        datasets: [
          {
            backgroundColor: '#3ba4da',
            data: [0, 0, 0, 224, 312, 360]
          }
        ]
      }, {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false,
            labels: {
                fontColor: 'rgb(255, 99, 132)'
            }
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/GuestsCount.vue